// extracted by mini-css-extract-plugin
export default {"cardContainer":"serveriKey_cardContainer__Vgzsw","cardtopborder":"serveriKey_cardtopborder__lCwuf","card":"serveriKey_card__w5M-s","cardContent":"serveriKey_cardContent__52mNq"};